import { fixNumString, IS_WEB, TRADE_REGX_NUMBER, TRADE_REGX_NUMBER_INTEGER } from "@adgm/libs";
import React from "react";
import { TextInput, TextInputProps } from "../platformComponents";

interface IProps extends TextInputProps {
  trim?: boolean;
  onValueChange?: ((text: string) => void) | undefined;
  valueType?: "text" | "number" | "email";
  precision?: number;
}

/**
 * 通用的TextInput组件,暂时需要限制输入的是数字,需要传入valueType == "number";需要小数精度传入precision;经过精度处理的数字会通过onValueChange回调
 * 注意:如果是非数字输入框,那么用法和TextInput完全相同,不会进行特殊处理
 */
export default class CommonInput extends React.PureComponent<IProps> {
  _onChange = (text: string) => {
    const { onChangeText, onValueChange, valueType, precision, value, trim = true } = this.props;
    if (trim) {
      text = text?.trim();
    }
    onChangeText && onChangeText(text);
    let newValue = text;
    let regex = TRADE_REGX_NUMBER;
    if (valueType == "number") {
      if (!precision) {
        regex = TRADE_REGX_NUMBER_INTEGER;
      }
      if (!text.match(regex)) {
        onValueChange && onValueChange(value ?? "");
        return;
      }
      newValue = fixNumString(text, precision ?? 0);
    }
    onValueChange && onValueChange(newValue);
  };

  render() {
    const { valueType, keyboardType, precision, ...otherProps } = this.props;
    let _keyboardType = keyboardType;
    if (!_keyboardType) {
      if (valueType == "number") {
        if (!precision) {
          //精度是0,不需要小数点
          _keyboardType = "phone-pad";
        } else {
          _keyboardType = "numeric";
        }
      } else if (valueType == "email") {
        _keyboardType = "email-address";
      }
    }
    return (
      <TextInput
        keyboardType={_keyboardType}
        onChangeText={this._onChange}
        {...otherProps}
        onFocus={e => {
          // 解决在Web中Input输入框获取焦点时出现轮廓线的问题
          if (IS_WEB && e.target) {
            // 先转换为unknown，再转换为HTMLInputElement，避免直接转换错误
            const target = e.target as unknown as HTMLInputElement;
            if (target && target.style) {
              target.style.outline = "none";
            }
          }
          otherProps.onFocus && otherProps.onFocus(e);
        }}
      />
    );
  }
}
